export default __webpack_public_path__ + "static/media/abs.c7f39736.jpg";